import { useEffect } from 'react';

export const getPrevPath = () => {
  return sessionStorage.getItem('prevPath');
};

const useUrlSessionStorage = (url: string) => {
  useEffect(() => {
    if (!sessionStorage) return;

    const prevPath = sessionStorage.getItem('currentPath');
    const currentPath = location.href;

    sessionStorage.setItem('prevPath', prevPath ?? currentPath);
    sessionStorage.setItem('currentPath', currentPath);
  }, [url]);
};

export default useUrlSessionStorage;
